"use strict";
import { useSetOverrideOneClickSwapFlag } from "pages/Swap/settings/OneClickSwap";
import { TransactionStepFailedError } from "uniswap/src/features/transactions/errors";
import { TransactionStepType } from "uniswap/src/features/transactions/steps/types";
import { useEvent } from "utilities/src/react/hooks";
function createGetOnPressRetry(ctx) {
  return function onPressRetry(error) {
    if (error instanceof TransactionStepFailedError) {
      if (error.step.type === TransactionStepType.SwapTransactionBatched) {
        return ctx.disableOneClickSwap;
      }
    }
    return void 0;
  };
}
export function useGetOnPressRetry() {
  const disableOneClickSwap = useSetOverrideOneClickSwapFlag();
  return useEvent(createGetOnPressRetry({ disableOneClickSwap }));
}
